/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { ChevronRight, ChevronDown } from 'sushiweb/Icons';
import { AddEdit } from 'sushiweb/Icons';
import { green } from 'sushiweb/tokens/color';

export const ChildNode = ({ node, rootId, openFormHandler }) => {
  return (
    <div
      className={`tw-flex tw-w-full tw-py-4 tw-px-5  tw-justify-between   tw-overflow-y-visible   ${
        node?.x === 'terminal' ? 'tw-bg-indigo-200' : 'tw-bg-base-white '
      } tw-rounded-xl tw-relative`}
    >
      <div className='tw-text-200 tw-font-medium'>{node.title}</div>
      <div className='tw-flex tw-gap-3 tw-cursor-pointer'>
        <div
          onClick={(e) => {
            e.stopPropagation();
            openFormHandler(
              false,
              node?.node_type === 'option' ? node?.id : node?.parent_id,
              rootId,
              node?.node_type,
              node?.node_type === 'option' ? 1 : 2,
              node?.id,
            );
          }}
        >
          {node?.has_children ? (
            <ChevronDown size={15} color={'#696969'} />
          ) : (
            <ChevronRight size={15} color={'#696969'} />
          )}
        </div>
        {node?.node_type === 'option' ? (
          <span
            className='tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center'
            onClick={(e) => {
              e.stopPropagation();
              openFormHandler(
                false,
                node?.id,
                rootId,
                node?.node_type,
                2,
                node?.id,
              );
            }}
          >
            <AddEdit size={12} color={green.z700} />
          </span>
        ) : null}
      </div>
    </div>
  );
};
